import { TextFieldProps, Typography } from "@mui/material";
import { ReactElement } from "react";
import { FieldValues, Path, UseControllerProps } from "react-hook-form";

import { FlexBox } from "~frontend/components/FlexBox";

import { RhfNumberField } from "./RhfNumberField";

export interface RhfNumberRangeProps<T extends FieldValues> {
  control: UseControllerProps<T>["control"];
  name: UseControllerProps<T>["name"];
  fullWidth?: boolean;
  bottomLabel?: string;
  lowLabel?: string;
  highLabel?: string;
  fieldKey?: string;
  variant?: TextFieldProps["variant"];
  sx?: TextFieldProps["sx"];
  slotProps?: TextFieldProps["slotProps"];
}

export function RhfNumberRange<T extends FieldValues>({
  control,
  name,
  fullWidth = true,
  bottomLabel,
  lowLabel = "Lower Limit",
  highLabel = "Upper Limit",
  fieldKey,
  variant,
  sx,
  slotProps,
}: RhfNumberRangeProps<T>): ReactElement {
  return (
    <FlexBox
      direction="column"
      gap={1}
      sx={{ width: fullWidth ? "100%" : "auto" }}
    >
      <FlexBox gap={2}>
        <RhfNumberField
          key={fieldKey ? `${fieldKey}-low` : undefined}
          control={control}
          name={`${name}[0]` as Path<T>}
          label={lowLabel}
          fullWidth
          variant={variant}
          sx={sx}
          slotProps={slotProps}
        />
        <RhfNumberField
          key={fieldKey ? `${fieldKey}-high` : undefined}
          control={control}
          name={`${name}[1]` as Path<T>}
          label={highLabel}
          fullWidth
          variant={variant}
          sx={sx}
          slotProps={slotProps}
        />
      </FlexBox>
      {bottomLabel && (
        <Typography variant="caption" color="textSecondary">
          {bottomLabel}
        </Typography>
      )}
    </FlexBox>
  );
}
